import { baseApi } from '@app/api/baseApi';
import type { LoginRequest, LoginResponse, User } from '@app/models/user';

interface ApiResponse<T> {
    success: boolean;
    message?: string;
    data: T;
}

export const authApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<ApiResponse<LoginResponse>, LoginRequest>({
            query: (credentials) => ({
                url: '/auth/login',
                method: 'POST',
                body: credentials,
            }),
        }),
        logout: builder.mutation<void, void>({
            query: () => ({
                url: '/auth/logout',
                method: 'POST',
            }),
        }),
        getCurrentUser: builder.query<ApiResponse<User>, void>({
            query: () => '/auth/profile',
            providesTags: ['Users'],
        }),
        refreshToken: builder.mutation<ApiResponse<LoginResponse>, { refreshToken: string }>({
            query: (body) => ({
                url: '/auth/refresh',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useLogoutMutation,
    useGetCurrentUserQuery,
    useRefreshTokenMutation,
} = authApi;
